import React from 'react';
import { motion } from 'framer-motion';
import { useI18n } from '../i18n/I18nContext';
import './ChampionTimeline.css';

const ACHIEVEMENTS = [
  { year: '2015–19', titleKey: 'timeline.title.1', tagKey: 'timeline.tag.national' },
  { year: '2017', titleKey: 'timeline.title.2', tagKey: 'timeline.tag.world' },
  {
    year: '2018',
    titleKey: 'timeline.title.3',
    noteKey: 'timeline.note.first',
    tagKey: 'timeline.tag.asiaPacific',
  },
  { year: '2018', titleKey: 'timeline.title.4', tagKey: 'timeline.tag.world' },
];

const ChampionTimeline = () => {
  const { t } = useI18n();
  return (
    <section
      id="champion-timeline"
      className="timeline-section"
      aria-labelledby="timeline-title"
    >
      <div className="timeline-inner">
        <motion.div
          className="timeline-intro"
          initial={{ y: 16, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.6 }}
        >
          <div className="timeline-avatar-wrap">
            <img
              src="/images/yichenghao.jpg"
              alt={t('timeline.founderAlt')}
              className="timeline-avatar"
              loading="lazy"
              decoding="async"
            />
            <span className="timeline-avatar-badge" aria-hidden>
              ★
            </span>
          </div>
          <p className="timeline-eyebrow">{t('timeline.founder')}</p>
          <h2 id="timeline-title" className="timeline-title">
            Cheng Hao Yi
          </h2>
          <blockquote className="timeline-quote">
            {t('timeline.quote')}
          </blockquote>
        </motion.div>

        <ol className="timeline-list" aria-label={t('timeline.achievements')}>
          {ACHIEVEMENTS.map((item, idx) => (
            <motion.li
              key={`${item.year}-${item.titleKey}`}
              className="timeline-item"
              initial={{ y: 20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: idx * 0.08 }}
            >
              <div className="timeline-item-marker" aria-hidden>
                ★
              </div>
              <div className="timeline-item-body">
                <div className="timeline-item-year">{item.year}</div>
                <div className="timeline-item-title">{t(item.titleKey)}</div>
                {item.noteKey && (
                  <div className="timeline-item-note">{t(item.noteKey)}</div>
                )}
                {item.tagKey && (
                  <span className="timeline-item-tag">{t(item.tagKey)}</span>
                )}
              </div>
            </motion.li>
          ))}
        </ol>

        <motion.div
          className="timeline-video-wrap"
          initial={{ y: 20, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
        >
          <iframe
            className="timeline-video"
            src="https://www.youtube.com/embed/MSDDD_k4vhk"
            title={t('timeline.videoTitle')}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            loading="lazy"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default ChampionTimeline;
